"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessages = void 0;
var React = require("react");
var react_intl_1 = require("react-intl");
var hasKeys_1 = require("./hasKeys");
function getErrorMessages(err, tag) {
    if (tag === void 0) { tag = 'div'; }
    if (!hasKeys_1.hasKeys(err)) {
        return null;
    }
    return Object.keys(err).map(function (key) {
        var values = Object.assign({}, err[key]);
        if (key === 'percentagemin') {
            values.min = React.createElement(react_intl_1.FormattedNumber, { style: "percent", value: values.min });
        }
        else if (key === 'percentagemax') {
            values.max = React.createElement(react_intl_1.FormattedNumber, { style: "percent", value: values.max });
        }
        else if (key === 'mindate' || key === 'maxdate') {
            values.requiredDate = (React.createElement(react_intl_1.FormattedDate, { year: "numeric", month: "long", day: "2-digit", value: values.requiredDate }));
        }
        else if (key === 'equalto') {
            values.equalto = (React.createElement("b", null,
                React.createElement(react_intl_1.FormattedMessage, { id: values.languageKey })));
        }
        return (React.createElement(react_intl_1.FormattedMessage, { key: key, id: "VALIDATORS." + key.toUpperCase(), tagName: tag, values: values }));
    });
}
exports.getErrorMessages = getErrorMessages;
//# sourceMappingURL=getErrorMessages.js.map